import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { formatNumber } from "../../lib/formatNumber";

const ChartTooltip = ({ active, payload, label, unit }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-border/20 bg-background/95 px-3 py-2 text-xs shadow-lg backdrop-blur">
      <p className="font-semibold text-foreground mb-1">{label}</p>
      <p className="text-muted-foreground">
        {formatNumber(payload[0].value)} {unit}
      </p>
    </div>
  );
};

// Single-series monthly bar chart - one metric, one hue (sequential/magnitude
// over time, not a category comparison), per the dataviz color rules.
const EsgMonthlyChart = ({ data, dataKey, unit, color, height = 220 }) => {
  const hasData = data?.some((d) => Number(d[dataKey]) > 0);
  if (!hasData) {
    return (
      <div
        className="flex items-center justify-center rounded-lg border border-dashed border-border/20 text-sm text-muted-foreground"
        style={{ height }}
      >
        No monthly data yet.
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" opacity={0.25} vertical={false} />
        <XAxis
          dataKey="month"
          tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
          axisLine={{ stroke: "hsl(var(--border))" }}
          tickLine={false}
        />
        <YAxis
          tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
          axisLine={false}
          tickLine={false}
          width={56}
          tickFormatter={(v) => formatNumber(v)}
        />
        <Tooltip content={<ChartTooltip unit={unit} />} cursor={{ fill: "hsl(var(--border))", opacity: 0.15 }} />
        <Bar dataKey={dataKey} fill={color} radius={[4, 4, 0, 0]} maxBarSize={36} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default EsgMonthlyChart;
